/** When your routing table is too long, you can split it into small modules**/

export default [
  {
    path: "/resume",
    name: "Resume",
    component: () => import("@/views/resume/Index"),
  },

  {
    path: "/resume/reportCard",
    name: "ReportCard",
    component: () => import("@/views/resume/ReportCard"),
  },
];
